import { combineReducers, createStore, compose } from 'redux';
import config from 'src/config';
import snackbarReducer from './ducks/snackbar';
import baseDialogReducer from './ducks/baseDialog';
import authReducer from './ducks/auth';
import categoryReducer from './ducks/category';
import productReducer from './ducks/product';
import userReducer from './ducks/user';

const reducer = combineReducers({
  snackbar: snackbarReducer,
  baseDialog: baseDialogReducer,
  auth: authReducer,
  category: categoryReducer,
  product: productReducer,
  user: userReducer,
});

const composeEnhancers = (
  config.env !== 'production'
  && typeof window !== 'undefined'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) || compose;

const store = createStore(
  reducer,
  composeEnhancers()
);

export default store;
